module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "chapnum"
  }, [_c('a', {
    attrs: {
      "id": "pg18"
    }
  }, [_vm._v("2")])]), _c('a', {
    attrs: {
      "id": "pg18"
    }
  }, [_c('p', {
    staticClass: "chaptit"
  }, [_vm._v("The Official County Seal for Seneca County, New York")])]), _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "pg18"
    }
  }, [_vm._v("The official seal for Seneca County, New York, was formally adopted by the board of supervisors on July 22, 1975. The former county seal had been just a plain white circle with the words “County of Seneca, New York” and a star around the edge with the word “Seal” in the center. The new county seal was in color and included several images that referred to important aspects of the rich history of Seneca County. How this new county seal came about is described by Sharon Secor, who was deputy clerk of the board of supervisors at the time. Secor said, “The Board of Supervisors had decided that it was time to update the County Seal to reflect actual representation of the county and its history. So a contest was held, not just limited to school kids, but open to anyone. A committee was formed to select one that was representative of the county and its history and present it to the Board.”")]), _c('span', {
    attrs: {
      "href": "#/Notes#Bch_5",
      "id": "Ach_5",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("5")])]), _vm._v(" The adopted design was actually a composite of a few submitted entries, with some changes made.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The elements on the seal represent the following corresponding aspects of the county and its history:")]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_c('i', [_vm._v("Indian head: Indian heritage")])]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Vote 1848: the Seneca Falls Women’s Rights Convention of July 19–20")])]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Scythe 1861: the Scythe Tree, on which James Wyman Johnson hung his scythe, near his house, and tells his parents he is going to enlist in the Union army")])]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Flag 1866: the first Memorial Day celebration in Waterloo")])]), _vm._v(" "), _c('div', {
    staticClass: "image-break"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/p19-01.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('a', {
    attrs: {
      "id": "pg19"
    }
  }, [_vm._v("The official Seneca County seal includes various images reflecting different aspects of the county’s rich history. "), _c('i', [_vm._v("Seneca County IT Department")]), _vm._v(".")])]), _c('a', {
    attrs: {
      "id": "pg19"
    }
  })]), _c('a', {
    attrs: {
      "id": "pg19"
    }
  }, [_c('p', {
    staticClass: "hang1"
  }, [_c('i', [_vm._v("Tractor: agriculture")])]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Buildings in skyline: industry")])]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Beehive 1830: establishment of the Church of Jesus Christ of Latter-day")])]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Saints (Mormon Church) by Joseph Smith; the Mormons later settled in Utah, which has the nickname the Beehive State")])]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Five stars 1968: establishment of Eisenhower College (Dwight Eisenhower was a five-star general)")])])]), _c('p', {
    staticClass: "indent1"
  }, [_c('a', {
    attrs: {
      "id": "pg19"
    }
  }, [_vm._v("The stylized letters "), _c('i', [_vm._v("S")]), _vm._v(" and "), _c('i', [_vm._v("C")]), _vm._v(" in the center stand for “Seneca County.” Their form also represents waves, depicting the two lakes that bound the county on the east and the west.")]), _c('span', {
    attrs: {
      "href": "#/Notes#Bch_6",
      "id": "Ach_6",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("6")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5b506226","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Chapter02.vue
// module id = 75
// module chunks = 0